import type { FaireProductEntity } from "../../entity_types/product";

export const p_6tk4ubxp44: FaireProductEntity = {
  token: "p_6tk4ubxp44",
  type: "product",
  name: "Black Midi Lace Short Sleeve Cocktail Dress",
  brandToken: "b_av43xzgdd9",
  brandName: "Kos Couture",
  imageUrl:
    "https://cdn.faire.com/fastly/81f847adc67df5123b18d2ab5b296719efdad4c0ba084fc830c012b374f65d2a.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7b8d9f8bc1096cc11d645c6b1722c25f8a0b6635528a424761149bbf2ec57142.webp",
    "https://cdn.faire.com/fastly/144e281127d4ea488dfe0cbcfc12f1f35cea09deb8c27367c43b1bcce0cf13cc.jpeg",
    "https://cdn.faire.com/fastly/75ce954877c4b5d76aca988cf83e515497e7822666e675f93d02e811a1164f22.jpeg",
    "https://cdn.faire.com/fastly/acfb2fe7c8134f57d98924bb1850ee1a8a21ff68a63dfb414ce7b887b1f9e6f2.webp",
  ],
  priceDollars: 74,
  description:
    "• Fabric: Lace\n• Length: Midi Length\n• Sleeve Style: Short Sleeve\n• Color: Black\n• Sizes: XS, S, M, L, XL, 2XL, 3XL, 4XL\n• Occasion: Cocktail Dresses, Formal Dresses, Homecoming Dresses\n• Designer: Dylan & Davids\n• Style: DD1349",
  tags: [],
  msrpDollars: 148,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:33.493Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
